import React from "react";
import '../styles/BannerCalculator.css'

const BannerCalculator = ({ data }) => {
    
    return(
        <section className={"banner-calculator xs:pt-24"}> 
            <div className="calculator-text">
                <h1 className="text-6xl xs:text-4xl">{data.title}</h1>
                <p className="text-xl max-w-md pb-4 pt-2 xs:text-lg">{data.text}</p>
                <div>
                    <p className="text-[#EC0000] xs:hidden">{data.textRed}</p>
                    <button className="action-primary">{data.actionPrimary}</button>
                </div>
            </div>
            <div className="calculator-images">
                <img src={data.image} alt={data.title}/>
            </div>
            <div className="calculator-text-two pt-20">
                <h1 className="text-6xl text-center leading-normal max-w-6xl 2xl:text-5xl xs:text-3xl xs:pb-4">{data.titleTwo}</h1>
            </div>
        </section>
    );
};

export default BannerCalculator; 